import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { GeneralService } from 'src/app/core/services/general.service';
import { InteractionService } from 'src/app/core/services/interaction.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { SettingsService } from 'src/app/core/services/settings.service';
import { UtilService } from 'src/app/core/services/util.service';

export interface Notification {
  adminCcAddress: any;
  adminStatus: any;
  allDeliveryMethod: any;
  countryCodes2char: any;
  defaultDeliveryMethod: string;
  defaultFrequency: any;
  notificationDescr: string;
  notificationEndDate: string;
  notificationId: string;
  notificationStartDate: string;
  notificationStatus: string;
  notificationType: string;
  partnerCode: any;
  thresholdValue: string;
  toggleStatus: string;
  icon?: string;
}

@Component({
  selector: 'papi-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css']
})
export class AccordionComponent {
  @Input() isOpen: boolean = false;
  @Input() partnerCode: string = '';
  @Input() userId: string = '';
  @Input() mainStatus: string = '';
  @Input() countries: Array<any> = [];
  @Input() countriesCount: any;
  @Input() emailId: string = '';
  @Input() notification: Notification | undefined;
  @Input() actor: 'admin' | 'partner' = 'partner';
  @Input() pendingChanges: { status?: string; threshold?: string; adminCCAddress?: string } | null = null;
  @Input() ccError: string = '';

  @Input() mainStatusChange?: any

  @Output() updateNotification: EventEmitter<any> = new EventEmitter();
  @Output() onToggleSwitch: EventEmitter<any> = new EventEmitter();
  @Output() onFrequencySelect: EventEmitter<any> = new EventEmitter();
  @Output() fieldChange: EventEmitter<{ notificationId: string; changes: any }> = new EventEmitter();
  @Output() detailsLoaded: EventEmitter<{ notificationId: string; details: any }> = new EventEmitter();
  channels: any[];
  defaultFreq: string;
  threshold: any;
  selChannelsId: any;
  notificationScheduleFrequency: any;
  frequency: unknown[];
  deliveryList: any;
  countryCodeArray: any;
  countryCode: any;
  thresholdCurrency: any;
  status: any;
  ccMailId: string = '';

  constructor(
    private notificationService: NotificationService,
    private settingsService: SettingsService,
    private generalService: GeneralService,
    private utilService: UtilService,
    private interaction: InteractionService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  emitToggleSwitch(on: any, notificationId: any) {
    this.status = on ? '1' : '2';
    this.onToggleSwitch.emit([on, notificationId, this.selChannelsId]);
    if (this.actor === 'admin') {
      this.emitFieldChange({ status: this.status });
    }
  }

  emitFieldChange(changes: any): void {
    if (!this.notification?.notificationId) {
      return;
    }
    this.fieldChange.emit({ notificationId: String(this.notification.notificationId), changes });
  }

  onThresholdBlur(): void {
    if (this.actor === 'admin') {
      this.emitFieldChange({ threshold: this.threshold });
      return;
    }
    this.updateNotificationLowBal();
  }

  onCcChange(value: string): void {
    this.ccMailId = value;
  }

  updateNotificationLowBal() {
    if (this.actor === 'admin') {
      return;
    }
    if(isNaN(Number(this.threshold)) == true){
      this.generalService.sendNote({
        text: 'Threshold should be a number.',
        duration: 4000,
        type: 'warning',
      });
      return;
    } 
    this.threshold = this.threshold.startsWith('+') ? this.threshold.slice(1) : this.threshold;
    let request = {
      userId: this.userId,
      notificationSetupId: '3',
      partnerCode: this.partnerCode,
      status: sessionStorage.getItem('lowBalanceStatusvalue'),
      deliveryMethod: this.selChannelsId,
      threshold: this.threshold,
      adminStatus: '',
      type: 'partner',
      adminEmailAddress: '',
      adminCCAddress: '',
    };

    if (
      sessionStorage.getItem('lowBalanceStatusvalue') != null &&
      this.selChannelsId.length > 0 &&
      this.threshold != ''
    ) {
      this.notificationService.updateNotification(request).subscribe((res: any) => {
        this.errorHandlerService.checkAndShowpageError(res.responseCode, 'notifications');
        //   localStorage.setItem('token_key', res.token);
        if (this.threshold === '') {
          let treshole = null;
          sessionStorage.setItem('thresholdValue', treshole);
        } else {
          let treshole = this.threshold;
          sessionStorage.setItem('thresholdValue', treshole);
        }
      });
    } else if (
      sessionStorage.getItem('lowBalanceStatusvalue') != null &&
      this.selChannelsId.length > 0 &&
      this.threshold === ''
    ) {
      this.generalService.sendNote({
        text: 'Threshold is a mandatory field, please enter a value.',
        duration: 4000,
        type: 'warning',
      });
      if (this.threshold === '') {
        let treshole = null;
        sessionStorage.setItem('thresholdValue', treshole);
      } else {
        let treshole = this.threshold;
        sessionStorage.setItem('thresholdValue', treshole);
      }
    } else if (
      sessionStorage.getItem('lowBalanceStatusvalue') != null &&
      this.selChannelsId.length === 0 &&
      this.threshold != ''
    ) {
      this.generalService.sendNote({
        text: 'Channel is a mandatory field, please select one.',
        duration: 4000,
        type: 'warning',
      });
      if (this.threshold === '') {
        let treshole = null;
        sessionStorage.setItem('thresholdValue', treshole);
      } else {
        let treshole = this.threshold;
        sessionStorage.setItem('thresholdValue', treshole);
      }
    } else if (
      sessionStorage.getItem('lowBalanceStatusvalue') != null &&
      this.selChannelsId.length === 0 &&
      this.threshold === ''
    ) {
      this.generalService.sendNote({
        text: 'Both threshold and channel are mandatory fields, please make selections for each.',
        duration: 4000,
        type: 'warning',
      });
      if (this.threshold === '') {
        let treshole = null;
        sessionStorage.setItem('thresholdValue', treshole);
      } else {
        let treshole = this.threshold;
        sessionStorage.setItem('thresholdValue', treshole);
      }
    }
  }

  emitUpdateNotification(): void {
    this.updateNotification.emit([this.threshold, '3', this.selChannelsId]);
  }

  openNotification(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen && (this.actor === 'admin' || this.mainStatus == 'On')) {
      this.getFrequencyChannelList();
    }
  }

  // Get data related to specific Notification type
  getFrequencyChannelList() {
    let request = {
      notificationSetupId: this.notification.notificationId,
      partnerCode: this.partnerCode,
      userId: this.userId,
      type: 'partner',
    };
    this.notificationService.getAllNotificationData(request).subscribe((res: any) => {
      this.errorHandlerService.checkAndShowpageError(res.responseCode, 'notifications');
      //localStorage.setItem('token_key', res.token);
      //Get comma seperated country list for rate Notifcation
      this.countryCode = res.result.responseData[0].countryCodes2char;
      this.thresholdCurrency = res.result.responseData[0].currency;
      if (this.countryCode != null) {
        this.countryCodeArray = this.countryCode.split(',');
      }
      // frequency list
      this.frequency = Object.values(res.result.responseData[0].frequencyList);
      //channels list
      this.deliveryList = res.result.responseData[0].deliveryList;
      //set default values
      this.getDefaultFrequency(res.result.responseData[0].notificationScheduleFrequency);
      this.getDefaultChannels(res.result.responseData[0].allDeliveryMethod, this.deliveryList);
      this.notificationScheduleFrequency = res.result.responseData[0].notificationScheduleFrequency;
      this.selChannelsId = res.result.responseData[0].allDeliveryMethod;
      this.status = res.result.responseData[0].status;
      if (res.result.responseData[0].threshold != null) {
        this.threshold = res.result.responseData[0].threshold;
      }
      this.ccMailId = res.result.responseData[0].adminCcAddress || '';
      if (this.pendingChanges) {
        if (this.pendingChanges.status != null) {
          this.status = this.pendingChanges.status;
        }
        if (this.pendingChanges.threshold != null) {
          this.threshold = this.pendingChanges.threshold;
        }
        if (this.pendingChanges.adminCCAddress != null) {
          this.ccMailId = this.pendingChanges.adminCCAddress;
        }
      }
      this.detailsLoaded.emit({
        notificationId: String(this.notification.notificationId),
        details: {
          status: this.status,
          threshold: this.threshold,
          adminCCAddress: this.ccMailId,
          currency: this.thresholdCurrency,
          notificationScheduleFrequency: this.notificationScheduleFrequency,
        },
      });
      // sessionStorage.setItem("statusvalue", this.statusvalue)
      if (this.countriesCount != null) {
        sessionStorage.setItem('selectedCountriesValue', this.countriesCount.toString());
      }
      sessionStorage.setItem('channelLength', res.result.responseData[0].allDeliveryMethod.length.toString());
    });
  }

  // Set default frequency values
  getDefaultFrequency(val) {
    if (val === '1') {
      this.defaultFreq = 'Daily';
    } else if (val === '2') {
      this.defaultFreq = 'Weekly';
    } else if (val === '3') {
      this.defaultFreq = 'Monthly';
    } else if (val === '4') {
      this.defaultFreq = 'Quarterly';
    } else if (val === '5') {
      this.defaultFreq = 'Yearly';
    }
  }

  // Set default channel value
  getDefaultChannels(arr: string[], obj) {
    let arrayOfObj = [];
    for (const key in obj) {
      let object1 = new Object();

      if (arr.includes(key)) {
        object1['name'] = obj[key];
        object1['checked'] = true;
      } else {
        object1['name'] = obj[key];
        object1['checked'] = false;
      }
      arrayOfObj.push(object1);
    }
    this.channels = arrayOfObj;
  }

  updatePredictiveNotification() {
    console.log('ccMailId', this.ccMailId);
    let request = {
      userId: this.userId,
      notificationSetupId: this.notification.notificationId,
      partnerCode:this.partnerCode,
      status: this.status,
      deliveryMethod: this.notification.defaultDeliveryMethod ? ['1'] : [],
      countryCodes2char: '',
      adminStatus: this.status,
      type: 'hub',
      adminEmailAddress: this.emailId,
      adminCCAddress: this.ccMailId.trim() || null,
    };
    this.notificationService.updateNotification(request).subscribe((res: any) => {
      this.errorHandlerService.checkAndShowpageError(res.responseCode, 'AdminNotification');
      this.generalService.sendNote({
        text: res.responseMessage,
        duration: 5000,
        type: 'success',
      });
      
    });
  }
}
